import { gql } from '@apollo/client';

export const GET_PRO_PLAN_PRICING_QUERY = gql`
  query GetProPlanPricingQuery {
    pricing_plan_types(where: { name: { _eq: "Pro Plan" } }) {
      pricing_plans {
        id
        name
      }
    }
  }
`;

export const GET_DEFAULT_PRICING_QUERY = gql`
  query GetDefaultPricingQuery {
    pricing_versions(where: { is_default: { _eq: true } }) {
      id
      pricing_currencies {
        id
        name
        description
      }
      pricing_periods(
        where: { _or: { is_lifetime: { _is_null: true } } }
        order_by: { order_number: asc }
      ) {
        id
        name
        description
        order_number
        is_default_selection
      }
      pricing_plan_types(order_by: { order_number: asc }) {
        id
        name
        description
        order_number
        is_freeplan
        is_enterprise
        is_lifetime
        pricing_plan_type_features(order_by: { order_number: asc }) {
          id
          name
          description
          is_title
          order_number
        }
        pricing_plans {
          id
          name
          description
          pricing_plan_type_id
          pricing_currency_id
          pricing_period_id
          pricing_plan_features(order_by: { order_number: asc }) {
            id
            name
            description
            is_title
            order_number
          }
          pricing_limitations {
            id
            type
            value_type
            value
          }
          pricing_price {
            id
            pricing_plan_id
            product_id
            amount
            amount_per_month
            actual_amount
            discount_amount
            discount_percentage
            discount_description
          }
        }
      }
    }
  }
`;

/**
 * Just enough of the lifetime plan to drive the countdown CTA that rides along
 * with every dashboard page. Deliberately small and cache-first: the full
 * pricing query is far too heavy to run app-wide, and the CTA must not appear
 * when the pricing tables carry no lifetime plan.
 */
export const GET_LIFETIME_PLAN_QUERY = gql`
  query GetLifetimePlanQuery {
    pricing_versions(where: { is_default: { _eq: true } }) {
      id
      pricing_plan_types(where: { is_lifetime: { _eq: true } }) {
        id
        name
        is_lifetime
        pricing_plans {
          id
          name
          pricing_currency_id
          pricing_price {
            id
            product_id
            amount
          }
        }
      }
    }
  }
`;

/**
 * Minimal query used to poll for lifetime activation after the user returns
 * from Stripe Checkout. The plan is activated by a webhook on a separate
 * connection, so it may not be live the instant the user lands back here.
 */
export const GET_ORGANIZATION_PLAN_STATUS_QUERY = gql`
  query GetOrganizationPlanStatusQuery($orgId: uuid!) {
    organization(where: { id: { _eq: $orgId } }) {
      id
      pricing_subscription {
        subscription_id
        status
        qty
        pricing_plan {
          id
          name
          pricing_plan_type {
            id
            name
            is_lifetime
          }
        }
      }
    }
  }
`;
